export async function settle(cb) {
  try {
    const data = await Promise.resolve(cb)
    return [false, data]
  } catch (err) {
    console.error(err)
    return [err, undefined]
  }
}
